import { render, staticRenderFns } from "./ItemMemoryiqPractice.vue?vue&type=template&id=96113fe4&"
import script from "./ItemMemoryiqPractice.vue?vue&type=script&lang=js&"
export * from "./ItemMemoryiqPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ItemMemoryiqPractice.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports